module.exports = __webpack_public_path__ + "img/icon_60px_32_blue.f4383bbf.svg";